const messages = require('./zh-CN/messages.json');

export default messages;
